import { Icon, forwardRef } from "@chakra-ui/react";
import * as React from "react";
export const SvgClaudeLogoIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(Icon, { ref, color: "foreground.secondary", fill: "none", focusable: "false", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 1l1.2 4.2L13 3.5l-2.6 3.4L14.5 8l-4.1 1.1L13 12.5l-3.8-1.7L8 15l-1.2-4.2L3 12.5l2.6-3.4L1.5 8l4.1-1.1L3 3.5l3.8 1.7L8 1z", fill: "#D97757" }));
});
export default SvgClaudeLogoIcon;
